/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gpa_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free GPA calculator. Add your courses with letter grades and credit hours to get a credit-weighted grade point average on the 4.0 scale.`)
};

const es_gpa_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de promedio académico gratuita. Añade tus asignaturas con notas y créditos para obtener un promedio ponderado por créditos en la escala de 4.0.`)
};

const de_gpa_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser GPA-Rechner. Trage deine Kurse mit Notenbuchstaben und Kreditstunden ein, um einen kreditgewichteten Notendurchschnitt auf der 4,0-Skala zu erhalten.`)
};

const nl_gpa_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis GPA calculator. Voeg je vakken toe met lettercijfers en studiepunten om een naar studiepunten gewogen gemiddelde te krijgen op de schaal van 4,0.`)
};

const fr_gpa_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de GPA gratuit. Ajoutez vos cours avec notes en lettres et crédits pour obtenir une moyenne pondérée par crédits sur l'échelle de 4,0.`)
};

const it_gpa_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore GPA gratuito. Aggiungi i tuoi corsi con voti in lettere e crediti per ottenere una media voti ponderata sui crediti nella scala 4.0.`)
};

const pt_br2_gpa_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de GPA gratuita. Adicione suas disciplinas com notas em letra e carga horária para obter uma média ponderada por créditos na escala de 4,0.`)
};

const pt_gpa_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de GPA gratuita. Adicione as suas disciplinas com notas em letra e horas de crédito para obter uma média ponderada por créditos na escala de 4,0.`)
};

const ja_gpa_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のGPA計算機。成績評価と単位数を入力するだけで、4.0スケールの単位加重平均成績点(GPA)を算出します。`)
};

const zh_gpa_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费 GPA 计算器。添加课程的等级成绩和学分，即可获得基于学分加权的 4.0 制平均绩点。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gpa_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gpa_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gpa_meta_description", locale)
	if (locale === "en") return en_gpa_meta_description(inputs)
	if (locale === "es") return es_gpa_meta_description(inputs)
	if (locale === "de") return de_gpa_meta_description(inputs)
	if (locale === "nl") return nl_gpa_meta_description(inputs)
	if (locale === "fr") return fr_gpa_meta_description(inputs)
	if (locale === "it") return it_gpa_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_gpa_meta_description(inputs)
	if (locale === "pt") return pt_gpa_meta_description(inputs)
	if (locale === "ja") return ja_gpa_meta_description(inputs)
	return zh_gpa_meta_description(inputs)
};